import { ColorTheme } from "../Models/Types";

export const defaultColors = {
  red: "#FF3737",
  orange: "#BF9000",
  green: "#548235",
};

export const themeColors: ColorTheme = {
  dark: "rgb(48, 48, 48)",
  main: "rgb(23, 22, 29)",
  lighter: "rgb(116, 116, 116)",
  light: "rgb(226, 226, 226)",
  textColor: "rgb(255, 255, 255)",
  contrastColor: "rgb(224, 121, 54)",
  background: "rgb(241, 241, 241)",
};

export const contrastColors = {
  dark: "#404040",
  main: "#AFABAB",
  lighter: "#e3e4e6",
  light: "#FFFFFF",
  shadowColor: "rgba(115,115,115,0.25)",
};
